import bowser from 'bowser';

export default angular
  .module('doxy.common.services.setSinkId', [])
  .factory('setSinkId', function () {
    /**
     * @param {HTMLMediaElement} element
     * @param {String} sinkId
     * @returns {Promise<false|undefined>}
     */
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    function setSinkId(element, sinkId) {
      const promise = angular.isUndefined(element.sinkId)
        ? Promise.reject(new Error('element.sinkId is undefined'))
        : element.setSinkId(sinkId);

      return promise.catch((err) => {
        console.error(
          'setSinkId(): Failed to set the audio output device:',
          err
        );
        throw err;
      });
    }

    let audio = window.Audio ? new Audio() : null;
    setSinkId.isSupported =
      // Ignore Firefox as it causes echo bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1849108
      !bowser.firefox && audio && !angular.isUndefined(audio.sinkId);
    audio = null;

    if (!setSinkId.isSupported) {
      console.warn('setSinkId is not supported');
    }

    return setSinkId;
  }).name;
